<template>
  <v-container fluid grid-list-xs class="fill-height">
    <v-row align="center" justify="center">
      <h1>404 NOT FOUND</h1>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: "PageNotFoundView",

  components: {},
};
</script>
<style></style>
